import { FilterSearch } from "./filter-search";
import { Filter } from "./filters/filter-block/filter-item/filter";
import { SearchList } from "./search-list";
import { BehaviorSubject } from 'rxjs';
import { HtmlUtilsService } from "../../html-utils/html-utils.service";
import { AppUtils } from "../../shared/app-utils";

export class RichSearchList extends SearchList {

  phrase: string;

  facets: Filter[] = [];

  filters: FilterSearch[] = [];

  moreAvailable: string[] = [];

  sortField: string = '';

  phraseSuggest: string = '';

  constructor(phrase: string, attr: { search?: any[], facets?: any[], filters?: any[], startIndex?: number, pageHits?: number, pageNumber?: number, pageSize?: number, totalPages?: number, totalHits?: number, sortField?: string, error?: string, phraseSuggest?: string, moreAvailable?: string[] } = {}, maxResultWindow: number) {
    super(attr, maxResultWindow);

    this.phrase = phrase;

    if (attr.filters) {
      attr.filters.forEach(f => this.filters.push(new FilterSearch(f)));
    }
    if (attr.facets) {
      attr.facets.forEach(f => {
        if (f.value !== "archive_object" && f.value !== "museum_object")// hidden Archiwalne Muzealne
          this.facets.push(new Filter(f))
      });
      if (AppUtils.checkCollectionIdInHref()) {
        let facet = attr.facets[0];
        facet.value = 'work_materialization';// add Bibliograficzne materializacje
        this.facets.push(new Filter(facet));
      }

      this.markFacetsFromFilters();
    }
    if (attr.moreAvailable) {
      attr.moreAvailable.forEach(f => this.moreAvailable.push(f));
    }

    if (attr.sortField) {
      this.sortField = attr.sortField;
    }
    this.phraseSuggest = attr.phraseSuggest;

  }


  private markChildrenFacetsFromFilters(filter, childrenFacet) {
    childrenFacet.forEach(children => {
      if (children.childFacetList) this.markChildrenFacetsFromFilters(filter, children.childFacetList);
      if (children.field === filter.field && children.value === filter.value) {
        children.excluded = filter.excluded;
        children.or = filter.or;
        children.selected = true;
      }
    });

  }

  private markFacetsFromFilters() {
    this.filters.forEach(filter => {
      let facetSelected = this.facets.find(facet => {
        if (facet.childFacetList) this.markChildrenFacetsFromFilters(filter, facet.childFacetList);
        return facet.field === filter.field && facet.value === filter.value;
      });
      if (facetSelected) {
        facetSelected.excluded = filter.excluded;
        facetSelected.or = filter.or;
        facetSelected.selected = true;
      }
    });
  }


}
